"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EXPERT_AUTH_UUID_DELIMITER = exports.VIEW_PREVIOUS_CACHE_TIMEOUT = exports.VIEW_CURRENT_CACHE_KEY = exports.VIEW_PREVIOUS_CACHE_KEY = exports.DEFAULT_NAMESPACE = exports.DEFAULT_COMMAND_KEY = exports.LOCAL_ENV_DEFAULT_PORT = exports.LOCAL_ENV_QUERY_PARAM = exports.EVENTS = exports.PLATFORM_WHITELIST = exports.DATA_REQUEST_RETRIES = exports.CHEGG_ID_REQUEST_RETRIES = exports.DELAY_BETWEEN_RETRIES = exports.SLOW_RESPONSE_THRESHOLD = exports.INIT_TIMEOUT_THRESHOLD = exports.DEFAULT_BATCH_INTERVAL = exports.LOGGING_NAMESPACE = exports.BASE_EVENT_TYPE = exports.BASE_EVENT_VERSION = exports.ADOBE = void 0;
// Data for obtaining user data from Adobe:
var ADOBE = {
  demdexUrl: 'https://chegginc.demdex.net/id?d_visid_ver=4.2.0&d_fieldgroup=MC&d_rtbd=json&d_ver=2&d_verify=1&d_orgid=3FE7CBC1556605A77F000101%40AdobeOrg&d_nsid=0&ts=',
  cacheBuster: 'cache_buster',
  cookieName: 'AMCV_3FE7CBC1556605A77F000101@AdobeOrg',
  adobeFallbackCookieName: 's_ecid',
  legacyCookieName: 'mcid',
  fallbackCookieName: 'local_fallback_mcid',
  responseIndex: 'mcid',
  timeout: 5000
}; // TODO: Import this dynamically when we switch to import
// the CES BaseEvent typing dynamically:

exports.ADOBE = ADOBE;
var BASE_EVENT_VERSION = '4';
exports.BASE_EVENT_VERSION = BASE_EVENT_VERSION;
var BASE_EVENT_TYPE = 'web'; // Prefixed to all logs and error events

exports.BASE_EVENT_TYPE = BASE_EVENT_TYPE;
var LOGGING_NAMESPACE = 'rio-sdk-web'; // Milliseconds for which events will be throttled, for the purpose of bulk sends:

exports.LOGGING_NAMESPACE = LOGGING_NAMESPACE;
var DEFAULT_BATCH_INTERVAL = 200; // Time until error is sent for slow/no RSW init:

exports.DEFAULT_BATCH_INTERVAL = DEFAULT_BATCH_INTERVAL;
var INIT_TIMEOUT_THRESHOLD = 7000; // Time until error is sent for slow request to server

exports.INIT_TIMEOUT_THRESHOLD = INIT_TIMEOUT_THRESHOLD;
var SLOW_RESPONSE_THRESHOLD = 5000; // Amount of time before the first failed request to the backend is retried.

exports.SLOW_RESPONSE_THRESHOLD = SLOW_RESPONSE_THRESHOLD;
var DELAY_BETWEEN_RETRIES = 50; // Max attempts to reach backend before abort/error.

exports.DELAY_BETWEEN_RETRIES = DELAY_BETWEEN_RETRIES;
var CHEGG_ID_REQUEST_RETRIES = 2;
exports.CHEGG_ID_REQUEST_RETRIES = CHEGG_ID_REQUEST_RETRIES;
var DATA_REQUEST_RETRIES = 8; // A list of acceptable device platforms on which events occur:

exports.DATA_REQUEST_RETRIES = DATA_REQUEST_RETRIES;
var PLATFORM_WHITELIST = ['tablet', 'mobile', 'desktop', 'tv', 'bot', undefined]; // Map of RSW event types and their corresponding chegg-event-spec specs:

exports.PLATFORM_WHITELIST = PLATFORM_WHITELIST;
var EVENTS = {
  pageview: {
    cheggDbEventName: 'page_view',
    version: '4.0.0'
  },
  cardEngagement: {
    cheggDbEventName: 'card_engagement',
    version: '3.0.0'
  },
  citationCreated: {
    cheggDbEventName: 'citation_created',
    version: '2.0.0'
  },
  paperUpload: {
    cheggDbEventName: 'paper_upload',
    version: '3.0.0'
  },
  transaction: {
    cheggDbEventName: 'transaction',
    version: '3.0.0'
  },
  slotRender: {
    cheggDbEventName: 'slot_render',
    version: '1.0.0'
  },
  videoEvent: {
    cheggDbEventName: 'video_event',
    version: '1.0.0'
  }
};
exports.EVENTS = EVENTS;
var LOCAL_ENV_QUERY_PARAM = 'use-local-rsw-port';
exports.LOCAL_ENV_QUERY_PARAM = LOCAL_ENV_QUERY_PARAM;
var LOCAL_ENV_DEFAULT_PORT = 8042;
exports.LOCAL_ENV_DEFAULT_PORT = LOCAL_ENV_DEFAULT_PORT;
var DEFAULT_COMMAND_KEY = 'wtaCmd';
exports.DEFAULT_COMMAND_KEY = DEFAULT_COMMAND_KEY;
var DEFAULT_NAMESPACE = 'default';
exports.DEFAULT_NAMESPACE = DEFAULT_NAMESPACE;
var VIEW_PREVIOUS_CACHE_KEY = 'rsw_view_previous_cache';
exports.VIEW_PREVIOUS_CACHE_KEY = VIEW_PREVIOUS_CACHE_KEY;
var VIEW_CURRENT_CACHE_KEY = 'rsw_view_current_cache';
exports.VIEW_CURRENT_CACHE_KEY = VIEW_CURRENT_CACHE_KEY;
var VIEW_PREVIOUS_CACHE_TIMEOUT = 3600000;
exports.VIEW_PREVIOUS_CACHE_TIMEOUT = VIEW_PREVIOUS_CACHE_TIMEOUT;
var EXPERT_AUTH_UUID_DELIMITER = '|';
exports.EXPERT_AUTH_UUID_DELIMITER = EXPERT_AUTH_UUID_DELIMITER;